/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Sources_PeriodicInputs */

const es_admin_billing_sources_periodic = /** @type {(inputs: Admin_Billing_Sources_PeriodicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periódica`)
};

const en_admin_billing_sources_periodic = /** @type {(inputs: Admin_Billing_Sources_PeriodicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodic`)
};

/**
* | output |
* | --- |
* | "Periodic" |
*
* @param {Admin_Billing_Sources_PeriodicInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_sources_periodic = /** @type {((inputs?: Admin_Billing_Sources_PeriodicInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Sources_PeriodicInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_sources_periodic(inputs)
	return en_admin_billing_sources_periodic(inputs)
});
export { admin_billing_sources_periodic as "admin.billing.sources.periodic" }